export default {
  title: '工廠管理',
  addFactory: '新增工廠',
  factoryInfo: '工廠資訊',
  factoryInfoPlaceholder: '請輸入工廠編號、工廠名稱',
  langRequired: '請選擇語言版本',
  factoryNo: '工廠編號',
  factoryName: '工廠名稱',
  factoryAddress: '工廠地址',
  addModal: '新增工廠',
  editModal: '編輯工廠',
  factoryNoPlaceholder: '請輸入工廠編號',
  factoryNamePlaceholder: '請輸入工廠名稱',
  factoryAddressPlaceholder: '請輸入工廠地址',
  requiredFactoryNo: '請輸入工廠編號',
  requiredFactoryName: '請輸入工廠名稱',
};
